import React from "react";
import "./home.scss";
import Navbar from "../Section/Header/navbar";
import Banner from "../Section/Banner/banner.jsx";
import About from "../Section/about/about";
import Promo from "../Section/Promo/promo.jsx";
import CharlotteAbout from "../Section/CharlotteAbout/CharlotteAbout.jsx";
import Charlotte from "../Section/Charlotte/Charlotte.jsx";
import HavelAbout from "../Section/HavelAbout/HavelAbout.jsx";
import Havel from "../Section/Havel/Havel.jsx";
import Lokasi from "../Section/Lokasi/lokasi.jsx";
import Footer from "../Section/Footer/footer.jsx";
import Scrolltohashelement from "./ScrollToHashElement";
import tombol from "../Media/tombol.webp";
const home = () => {
  const fungsiganteng = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6282337730895&text=Halo%20Mikael,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20Citraland%20City%20Kedamean%20https://citraland-city-kedamean.id//&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };
  return (
    <div className="home">
      <Scrolltohashelement />
      <Navbar />
      <Banner />
      <About />
      <Promo />
      <CharlotteAbout />
      <Charlotte />
      <HavelAbout />
      <Havel />
      <Lokasi />
      <Footer />
      <img
        onClick={fungsiganteng}
        src={tombol}
        className="tombolwa"
        alt="Hubungi Sekarang!"
      />
    </div>
  );
};

export default home;
